<template>
  <div id="app">
  	<Navbar />
    <MainLayout />
  </div>
</template>

<script>
import MainLayout from './components/MainLayout';
import Navbar from './components/Navbar';

export default{
  	name: 'app',
  	components:{ MainLayout, Navbar }
}
</script>


<style lang="scss">
	@import url('https://fonts.googleapis.com/css?family=Montserrat:400,900|Raleway:400&display=swap');
	@import "./assets/scss/_variables.scss";

	*, *:after, *:before{
		-webkit-box-sizing: border-box;
		-moz-box-sizing: border-box;
		box-sizing: border-box;
	}
	
	::-webkit-scrollbar {
		display: none;
	}

	#app {
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		display: grid;
		grid-template-rows: 10vh 90vh;
		overscroll-behavior: none;
	}

	@media screen and (max-width: $tabletWidth){
	}

	@media screen and (max-width: $largeMobile){
		#app{
			grid-template-rows: 0vh 100vh;
		}
	}
</style>
